module.exports = __webpack_public_path__ + "static/media/comunicacao.75de314f.png";